import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { shouldRefreshToken } from '../services/api';

const isDev = import.meta.env.DEV;

/**
 * Hook qui surveille la navigation et renouvelle automatiquement le token si nécessaire
 */
export const useTokenRefresh = () => {
  const { isAuthenticated, refreshTokenIfNeeded } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Only refresh on route changes if token actually needs refreshing
    // This prevents unnecessary API calls
    if (isAuthenticated) {
      const needsRefresh = shouldRefreshToken();
      if (needsRefresh) {
        if (isDev) {
          console.log('useTokenRefresh: Token needs refresh on route change to', location.pathname);
        }
        refreshTokenIfNeeded().catch((error: unknown) => {
          console.warn('Token refresh failed during navigation:', error);
        });
      } else {
        if (isDev) {
          console.log('useTokenRefresh: Token is still valid on route change to', location.pathname);
        }
      }
    }
  }, [location.pathname, isAuthenticated, refreshTokenIfNeeded]);
};
